import React from "react";

import { Close } from "@libraries/icons";
import { IconButton } from "@libraries/mui";

import * as Styled from "./styles";

interface IModalFormDialog {
  title: string;
  open: boolean;
  onClose?: () => void;
}

const ModalFormDialog: React.FC<IModalFormDialog> = ({
  title,
  open,
  onClose,
  children
}) => (
  <Styled.Container open={open}>
    <Styled.Header>
      <Styled.Title>{title}</Styled.Title>
      {onClose && (
        <IconButton onClick={onClose}>
          <Close fontSize="large" />
        </IconButton>
      )}
    </Styled.Header>
    {children}
  </Styled.Container>
);

ModalFormDialog.defaultProps = {
  onClose: undefined
};

export default ModalFormDialog;
